import styled from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { fontWeightDefault } from '@yme/tokens/typography';
export const MiniButtonStyled = styled(MiniButton) `
  span {
    ${fontWeightDefault};
  }
`;
